jQuery(function ($) {
  'use strict';
  var faqDurationMs = 300;

  $('.fixedcontainer .title').each(function () {
    var $title = $(this);
    var html = $title.html();
    if (
      typeof html !== 'string' ||
      html.indexOf('生産管理システム') === -1 ||
      html.indexOf('<span>生産管理システム</span>') !== -1
    ) {
      return;
    }
    $title.html(html.replace('生産管理システム', '<span>生産管理システム</span><br class="sp-only">'));
  });

  var isProductionManagementTop =
    typeof smartfLpProduction !== 'undefined' && !!smartfLpProduction.isProductionManagementTop;

  $('.fixedcontainer').each(function () {
    var $container = $(this);
    if ($container.find('.fixedcontainer-btn.ajust-none').length) {
      return;
    }
    var isComparisonTable = $container.find('.smartf-comparison-table').length > 0;
    var priceUnitHtml =
      "<div class='service-btn-unit price-unit'>" +
      "<p class='sv__btn--subHead'><span>料金体系の確認はこちら</span></p>" +
      "<a href='./price' class='service-btn btn-download no-link' rel='noopener'>料金について詳しく見る</a>" +
      '</div>';
    var unitsHtml = priceUnitHtml;
    if (isComparisonTable && isProductionManagementTop) {
      var compareUnitHtml =
        "<div class='service-btn-unit compare-unit'>" +
        "<p class='sv__btn--subHead'><span>生産管理システムを比較検討している方必見！</span></p>" +
        "<a href='/comparison-evaluation-pack' class='service-btn btn-download compare-btn no-link' rel='noopener'>比較検討パックを受け取る（無料）</a>" +
        '</div>';
      unitsHtml = compareUnitHtml + priceUnitHtml;
    }
    $container.append("<div class='fixedcontainer-btn ajust-none'>" + unitsHtml + '</div>');
  });

  var $casesSlider = $('.js-service-cases-slider');
  if ($casesSlider.length && typeof $casesSlider.slick === 'function') {
    $casesSlider.on('init', function () {
      $casesSlider.addClass('is-ready');
    });
    $casesSlider.slick({
      slidesToShow: 3.8,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 15000,
      cssEase: 'linear',
      arrows: false,
      dots: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.3,
          },
        },
      ],
    });
  }

  var $faqItems = $('.service-faq__item');
  $faqItems.each(function () {
    var $item = $(this);
    var $answer = $item.find('.service-faq__answer');
    if ($item.hasClass('is-open')) {
      $answer.show();
    } else {
      $answer.hide();
    }
  });

  $('.service-faq__question').on('click', function (e) {
    e.preventDefault();
    var $item = $(this).closest('.service-faq__item');
    var $answer = $item.find('.service-faq__answer');
    if ($item.hasClass('is-open')) {
      $item.removeClass('is-open');
      $answer.stop(true, true).slideUp(faqDurationMs);
      return;
    }
    $item.addClass('is-open');
    $answer.stop(true, true).slideDown(faqDurationMs);
  });

  var $pmCasesSlider = $('.js-pm-cases-slider');
  if ($pmCasesSlider.length && typeof $pmCasesSlider.slick === 'function') {
    $pmCasesSlider.on('init', function () {
      $pmCasesSlider.addClass('is-ready');
    });
    $pmCasesSlider.slick({
      slidesToShow: 3.8,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 15000,
      cssEase: 'linear',
      arrows: false,
      dots: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.3,
          },
        },
      ],
    });
  }

  var $pmFaqItems = $('.pm-faq-item');
  $pmFaqItems.each(function () {
    var $item = $(this);
    var $answer = $item.find('.pm-faq-a');
    if ($item.hasClass('is-open')) {
      $answer.show();
    } else {
      $answer.hide();
    }
  });

  $('.pm-faq-q').on('click', function (e) {
    e.preventDefault();
    var $item = $(this).closest('.pm-faq-item');
    var $answer = $item.find('.pm-faq-a');
    if ($item.hasClass('is-open')) {
      $item.removeClass('is-open');
      $answer.stop(true, true).slideUp(faqDurationMs);
      return;
    }
    $item.addClass('is-open');
    $answer.stop(true, true).slideDown(faqDurationMs);
  });
});
